import env from "src/core/env";
import { Repository } from "src/core/Repository";
import {
  ExportToWordRequest,
  ExportFileResponse,
  GetAllListReportResponse,
} from "src/models/report";
import { DeleteRequest } from "src/models/Request";
import {
  getAllPhongs,
  editPhongsProps,
  addPhongsProps,
  DetailsRequest,
} from "src/models/phongs";
class ReportRepository extends Repository<
  ExportToWordRequest,
  ExportFileResponse
> {
  protected basePath = "api/cms-service/";

  constructor() {
    super(env.API_CMS_URL);
  }

  getAllListPhongs(params: getAllPhongs) {
    return this.request<GetAllListReportResponse>({
      method: "GET",
      url: "phongs/all",
      params,
    });
  }

  getDetailsPhongs(param: DetailsRequest) {
    return this.request<GetAllListReportResponse>({
      method: "GET",
      url: `phongs/${param.id}`,
    });
  }

  deletePhongs(param: DeleteRequest) {
    return this.request({
      method: "DELETE",
      url: `phongs/${param.id}`,
    });
  }

  editPhongs(params: editPhongsProps) {
    return this.request({
      method: "PUT",
      url: "phongs",
      data: params,
    });
  }

  addPhongs(params: addPhongsProps) {
    return this.request({
      method: "POST",
      url: "phongs",
      data: params,
    });
  }
}

export default new ReportRepository();
